module.exports = __webpack_public_path__ + "static/teriyakiLogo-b66b3a4bbf8b43859a7c582edd3e6667.png";